<template>
  <div>
    <b-alert show v-if="runningVersionRelative > 0">
      <h4>Release-candidate version now running</h4>
      <!-- <h4>You are running version {{runningVersion}}.</h4>
      <h4>Firebase only knows of {{latestVersion}}.</h4>
      <h6>Presumably you've just started the Build/Deploy process, creating a new version value but not notified users at large via Firebase. If the situation persists for over 2 min, check the build process for errors.</h6> -->
    </b-alert>

    <b-alert show v-if="runningVersionRelative < 0" class="m-2">
      <h3>New version available</h3>
      <div v-if="canUpdateNow">
        <h5>
          There is a new version of this App. The App will shortly update
          itself, and this message will disappear.
        </h5>
      </div>
      <div v-else>
        <h5>
          Relax. Complete your data entry. Until then, this App will wait
          patiently.
        </h5>
        <hr />
        <h6>
          Message still here, even after you've finished?
          <b-button variant="outline-dark" size="sm" @click="getNewest"
            >Update now</b-button
          >
        </h6>
      </div>
    </b-alert>

    <!-- <b-alert show v-if="runningVersionRelative===0" class="m-2">
      <small> D{{runningVersionRelative}} R{{runningVersion}} L{{latestVersion}}</small>
      </b-alert> -->
  </div>
</template>

<script>
import { BUILDVERSION } from "./from_st_elsewhere/BuildVersion.js"; // This is overwritten by the building process

import {
  systemStatusRef, // just in the global space, non- "this."
} from "../firebaseSetup.js";

import { getNewest } from "./utilGetNewest.js"; // but remember to also re-export it in methods

export default {
  props: {
    canUpdateNow: { type: Boolean, default: false },
  },
  data: function () {
    return {
      runningVersion: BUILDVERSION,
      latestVersion: "",
      latestVersionRead: false,
    };
  },
  computed: {
    runningVersionRelative: function () {
      if (this.latestVersionRead) {
        if (this.runningVersion > this.latestVersion) {
          return +1; // The version running is NEWER than the one listed on firebase, which will happen if you have half-run the build script and then aborted it (or while it runs) are serving it locally via NPM RUN DEV.
        } else if (this.runningVersion < this.latestVersion) {
          if (this.canUpdateNow) {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(getNewest, 10000);
          }
          return -1; // The version running is OLDER than the one listed on firebase, which means you should update
        } else {
          return 0; // You are up to date
        }
      }
      return undefined;
    },
  },
  created() {
    systemStatusRef.on("value", (snapshot) => {
      this.latestVersion = (snapshot.val() || {}).latestVersion;
      this.latestVersionRead = true;
    });
  },
  methods: {
    getNewest, // This is just a re-export so the imported function which went into the global space (that can't be seen by the template) is re-exported as this.getNewest, so it *can* be seen by the template.
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AppAutoupdate.vue